module.exports = __webpack_public_path__ + "static/media/amusement(2).588d26f3.PNG";